import {Action} from "redux";
import {ISettingsContainerState} from "./settings";
import {IMarket} from "@montana/models/generated/cms.interface";

export enum SettingsAction {
    INIT_SETTINGS = "@@settings/INIT_SETTINGS",
    PERSIST_SETTINS = "@@settings/PERSIST_SETTINS",
    SET_CUSTOMER_MODE = "@@settings/SET_CUSTOMER_MODE",
    SET_LANGUAGE_AND_MARKET = "@@settings/SET_LANGUAGE_AND_MARKET",
    CHANGE_LANGUAGE_AND_MARKET = "@@settings/CHANGE_LANGUAGE_AND_MARKET",
    SET_INFO_TOOLBOX = "@@settings/SET_INFO_TOOLBOX",
    SET_LANGUAGE = "@@settings/SET_LANGUAGE"
}

export type ISettingsAction =
    IPersistSettingsAction |
    IInitSettingsAction |
    ISetCustomerModeSettingsAction |
    IChangeLanguageAndMarket |
    ISetLanguageAndMarket |
    ISetLanguage |
    ISetInfoToolboxAction;

export interface IChangeLanguageAndMarket
    extends Action<SettingsAction.CHANGE_LANGUAGE_AND_MARKET> {
    language: string;
    market: IMarket;
    url: string;
}

export interface ISetLanguageAndMarket
    extends Action<SettingsAction.SET_LANGUAGE_AND_MARKET> {
    language: string;
    market: IMarket;
}

export interface ISetLanguage
    extends Action<SettingsAction.SET_LANGUAGE> {
    language: string;
}

export interface ISetInfoToolboxAction extends Action<SettingsAction.SET_INFO_TOOLBOX> {
    infoToolbox: string;
}

export interface IInitSettingsAction extends Action<SettingsAction.INIT_SETTINGS> {
    settings: ISettingsContainerState;
}

export type IPersistSettingsAction = Action<SettingsAction.PERSIST_SETTINS>;

export interface ISetCustomerModeSettingsAction extends Action<SettingsAction.SET_CUSTOMER_MODE> {
    customerMode: string;
}

export const changeLanguageAndMarket = (
    language: string,
    market: IMarket,
    url: string
): IChangeLanguageAndMarket => ({
    type: SettingsAction.CHANGE_LANGUAGE_AND_MARKET,
    language,
    market,
    url
});

export const setLanguageAndMarket = (
    language?: string,
    market?: IMarket
): ISetLanguageAndMarket => {
    return {
        type: SettingsAction.SET_LANGUAGE_AND_MARKET,
        language,
        market
    } as ISetLanguageAndMarket;
};

export const setLanguage = (
    language?: string,
): ISetLanguage => {
    const lang = {} as Omit<ISetLanguage, 'type'>;

    if (language) {
        lang.language = language;
    }

    return {
        type: SettingsAction.SET_LANGUAGE,
        ...lang
    }
};

export const setInfoToolbox = (infoToolboxKey: string): ISetInfoToolboxAction => ({
    type: SettingsAction.SET_INFO_TOOLBOX,
    infoToolbox: infoToolboxKey
})

export const initSettings = (settings: ISettingsContainerState): IInitSettingsAction => ({
    type: SettingsAction.INIT_SETTINGS,
    settings
});

export const persistSettings = (): IPersistSettingsAction => ({
    type: SettingsAction.PERSIST_SETTINS
});

export const setCustomerMode = (customerMode: string): ISetCustomerModeSettingsAction => ({
    type: SettingsAction.SET_CUSTOMER_MODE,
    customerMode,
});

